export const UtilizationGraphPlugin = {
  id: 'utilization_graph_plugin',
  afterDatasetsDraw: function (chart: any, easing: any) {
    const ctx = chart.ctx;
    const chartArea = chart.chartArea;

    const gradient = ctx.createLinearGradient(
      0,
      chartArea.bottom,
      0,
      chartArea.top
    );
    const stops = [
      0.05, 0.12, 0.19, 0.26, 0.34, 0.42, 0.5, 0.57, 0.65, 0.73, 0.8,
    ];
    const colors = [
      'rgba(0, 0, 0, 1)',
      'rgba(0, 0, 0, 0.9)',
      'rgba(0, 0, 0, 0.8)',
      'rgba(0, 0, 0, 0.7)',
      'rgba(0, 0, 0, 0.6)',
      'rgba(0, 0, 0, 0.5)',
      'rgba(0, 0, 0, 0.4)',
      'rgba(0, 0, 0, 0.3)',
      'rgba(0, 0, 0, 0.2)',
      'rgba(0, 0, 0, 0.1)',
      'rgba(0, 0, 0, 0)',
    ];

    for (let i = 0; i < stops.length; i++) {
      gradient.addColorStop(stops[i], colors[i]);
    }

    ctx.save();
    ctx.fillStyle = gradient;
    ctx.fillRect(
      chartArea.left,
      chartArea.top,
      chartArea.right - chartArea.left,
      chartArea.bottom - chartArea.top
    );
    ctx.restore();
  },
};

export const UTILIZATION_RATE_GRAPH_CONFIG = {
  maintainAspectRatio: false,
  scales: {
    x: {
      display: false,
    },
    y: {
      beginAtZero: false,
      display: false,
      stacked: true,
    },
  },
};
